import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

const useHandleHeightSelector = () => {
  const addToQuote = useStore((state) => state.addToQuote);
  const doorType = useStore((state) => state.quote.doorType);

  const handleHeightChoice = useStore((state) => state.quote.handleHeight);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleClick = (label: string) => {
    const checked = label === handleHeightChoice;

    if (checked) {
      addToQuote({ handleHeight: "" }, "handleHeight");
    } else {
      if (doorType === "Pivot") {
        if (findRequired("Thumb Turn Height"))
          removeRequired("Thumb Turn Height");
      } else {
        if (findRequired("Handle Height")) removeRequired("Handle Height");
      }
      addToQuote({ handleHeight: label });
    }
  };

  const heading =
    doorType === "Bi-fold"
      ? "Handle/Shoot-bolt Height"
      : doorType === "Pivot"
      ? "Thumb Turn Height"
      : "Handle Height";

  return {
    heading,
    handleClick,
    handleHeightChoice,
  };
};

export default useHandleHeightSelector;
